import React, { useState, useEffect, useRef } from 'react';
import { Loader2,ArrowRightLeft, Building2, Wallet, CreditCard, TrendingUp, TrendingDown, Plus, Search, Filter, Calendar, CheckCircle, AlertCircle, ArrowRight, ChevronDown, X } from 'lucide-react';
import config from '../config/config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const AccountTransferManager = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('transfer');
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferAmount, setTransferAmount] = useState('');
  const [fromAccount, setFromAccount] = useState('');
  const [toAccount, setToAccount] = useState('');
  const [description, setDescription] = useState('');
  const [reference, setReference] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const[transactions,setTransactions]=useState([]);
  const[accounts,setAccounts]=useState([]);
  const[journalEntries,setJournalEntries]=useState([]);
  
  // Account selection states
  const [fromAccountSearch, setFromAccountSearch] = useState('');
  const [toAccountSearch, setToAccountSearch] = useState('');
  const [showFromDropdown, setShowFromDropdown] = useState(false);
  const [showToDropdown, setShowToDropdown] = useState(false);
  const [selectedFromAccount, setSelectedFromAccount] = useState(null);
  const [selectedToAccount, setSelectedToAccount] = useState(null);
  
  const fromDropdownRef = useRef(null);
  const toDropdownRef = useRef(null);


   // Fetch benefits/deductions
  const fetchPettyCash = async (companyId = 1) => {
    setLoading(true);

    try {
      const response = await fetch(`${config.API_URL}/api/fetch-transfer-cash/${companyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
     const data = await response.json();
      //console.log('Benefits/Deductions API response:', data);

      setTransactions(data.transactions || []);
      setAccounts(data.accounts || []);
      setJournalEntries(data.journals || []);
       //alert(response.data.deposits);
       setLoading(false);
     
      //console.log(response.data.accounts);
    } catch (err) {
      setLoading(false);
      //setError('Failed to fetch benefits/deductions');
      //console.error('Fetch benefits/deductions error:', err);
    }
  }; 

    const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) return decodeURIComponent(match[2]);
    return null;
  };

  
    useEffect(() => {
    
    //console.log('Fetching initial data with token:', token);
    
    fetchPettyCash();
  }, [token]);

  // Sample accounts data (expanded for demo)
  const [accountz, setAccountz] = useState([
    // Assets - Current
    { id: 'cash', name: 'Cash in Hand', code: '1001', type: 'asset', category: 'current', balance: 5500.00, normalBalance: 'debit' },
    { id: 'checking', name: 'Checking Account', code: '1100', type: 'asset', category: 'current', balance: 45230.00, normalBalance: 'debit' },
    { id: 'savings', name: 'Business Savings', code: '1200', type: 'asset', category: 'current', balance: 125000.00, normalBalance: 'debit' },
    { id: 'petty-cash', name: 'Petty Cash Fund', code: '1050', type: 'asset', category: 'current', balance: 2500.00, normalBalance: 'debit' },
    { id: 'money-market', name: 'Money Market Account', code: '1210', type: 'asset', category: 'current', balance: 75000.00, normalBalance: 'debit' },
    { id: 'accounts-receivable', name: 'Accounts Receivable', code: '1300', type: 'asset', category: 'current', balance: 18750.00, normalBalance: 'debit' },
    { id: 'inventory', name: 'Inventory', code: '1400', type: 'asset', category: 'current', balance: 32000.00, normalBalance: 'debit' },
    { id: 'prepaid-insurance', name: 'Prepaid Insurance', code: '1500', type: 'asset', category: 'current', balance: 3600.00, normalBalance: 'debit' },
    { id: 'prepaid-rent', name: 'Prepaid Rent', code: '1510', type: 'asset', category: 'current', balance: 6000.00, normalBalance: 'debit' },
    { id: 'office-supplies', name: 'Office Supplies', code: '1520', type: 'asset', category: 'current', balance: 1200.00, normalBalance: 'debit' },
    
    // Assets - Fixed
    { id: 'equipment', name: 'Office Equipment', code: '1600', type: 'asset', category: 'fixed', balance: 25000.00, normalBalance: 'debit' },
    { id: 'vehicles', name: 'Company Vehicles', code: '1700', type: 'asset', category: 'fixed', balance: 45000.00, normalBalance: 'debit' },
    { id: 'building', name: 'Building', code: '1800', type: 'asset', category: 'fixed', balance: 250000.00, normalBalance: 'debit' },
    { id: 'land', name: 'Land', code: '1900', type: 'asset', category: 'fixed', balance: 100000.00, normalBalance: 'debit' },
    
    // Liabilities - Current
    { id: 'accounts-payable', name: 'Accounts Payable', code: '2100', type: 'liability', category: 'current', balance: 12400.00, normalBalance: 'credit' },
    { id: 'wages-payable', name: 'Wages Payable', code: '2200', type: 'liability', category: 'current', balance: 8500.00, normalBalance: 'credit' },
    { id: 'taxes-payable', name: 'Taxes Payable', code: '2300', type: 'liability', category: 'current', balance: 5200.00, normalBalance: 'credit' },
    { id: 'credit-line', name: 'Business Credit Line', code: '2400', type: 'liability', category: 'current', balance: 15000.00, normalBalance: 'credit' },
    { id: 'accrued-expenses', name: 'Accrued Expenses', code: '2500', type: 'liability', category: 'current', balance: 3200.00, normalBalance: 'credit' },
    
    // Liabilities - Long-term
    { id: 'loan-payable', name: 'Bank Loan Payable', code: '2600', type: 'liability', category: 'long-term', balance: 125000.00, normalBalance: 'credit' },
    { id: 'mortgage', name: 'Building Mortgage', code: '2700', type: 'liability', category: 'long-term', balance: 185000.00, normalBalance: 'credit' },
    { id: 'equipment-loan', name: 'Equipment Loan', code: '2800', type: 'liability', category: 'long-term', balance: 18500.00, normalBalance: 'credit' },
    
    // Equity
    { id: 'capital', name: "Owner's Capital", code: '3100', type: 'equity', category: 'capital', balance: 150000.00, normalBalance: 'credit' },
    { id: 'retained-earnings', name: 'Retained Earnings', code: '3200', type: 'equity', category: 'retained', balance: 85080.00, normalBalance: 'credit' },
    { id: 'drawings', name: "Owner's Drawings", code: '3300', type: 'equity', category: 'drawings', balance: 12000.00, normalBalance: 'debit' },
    
    // Revenue
    { id: 'sales-revenue', name: 'Sales Revenue', code: '4100', type: 'revenue', category: 'operating', balance: 285000.00, normalBalance: 'credit' },
    { id: 'service-revenue', name: 'Service Revenue', code: '4200', type: 'revenue', category: 'operating', balance: 125000.00, normalBalance: 'credit' },
    { id: 'interest-income', name: 'Interest Income', code: '4300', type: 'revenue', category: 'non-operating', balance: 2500.00, normalBalance: 'credit' },
    
    // Expenses
    { id: 'office-expenses', name: 'Office Expenses', code: '5100', type: 'expense', category: 'operating', balance: 12500.00, normalBalance: 'debit' },
    { id: 'rent-expense', name: 'Rent Expense', code: '5200', type: 'expense', category: 'operating', balance: 36000.00, normalBalance: 'debit' },
    { id: 'salary-expense', name: 'Salary Expense', code: '5300', type: 'expense', category: 'operating', balance: 156000.00, normalBalance: 'debit' },
    { id: 'utilities-expense', name: 'Utilities Expense', code: '5400', type: 'expense', category: 'operating', balance: 8400.00, normalBalance: 'debit' },
    { id: 'insurance-expense', name: 'Insurance Expense', code: '5500', type: 'expense', category: 'operating', balance: 14400.00, normalBalance: 'debit' },
    { id: 'maintenance-expense', name: 'Maintenance Expense', code: '5600', type: 'expense', category: 'operating', balance: 6800.00, normalBalance: 'debit' },
    { id: 'marketing-expense', name: 'Marketing Expense', code: '5700', type: 'expense', category: 'operating', balance: 18500.00, normalBalance: 'debit' },
    { id: 'travel-expense', name: 'Travel Expense', code: '5800', type: 'expense', category: 'operating', balance: 9200.00, normalBalance: 'debit' },
    { id: 'depreciation-expense', name: 'Depreciation Expense', code: '5900', type: 'expense', category: 'operating', balance: 15600.00, normalBalance: 'debit' },
    { id: 'interest-expense', name: 'Interest Expense', code: '6100', type: 'expense', category: 'non-operating', balance: 8900.00, normalBalance: 'debit' }
  ]);

  const [journalEntriez, setJournalEntriez] = useState([
    {
      id: 1,
      date: '2024-09-24',
      reference: 'TRF001',
      description: 'Transfer from Checking to Petty Cash',
      entries: [
        { account: 'petty-cash', accountName: 'Petty Cash Fund', debit: 500.00, credit: 0 },
        { account: 'checking', accountName: 'Checking Account', debit: 0, credit: 500.00 }
      ],
      total: 500.00,
      status: 'posted'
    },
    {
      id: 2,
      date: '2024-09-23',
      reference: 'TRF002',
      description: 'Transfer from Savings to Checking for operations',
      entries: [
        { account: 'checking', accountName: 'Checking Account', debit: 10000.00, credit: 0 },
        { account: 'savings', accountName: 'Business Savings', debit: 0, credit: 10000.00 }
      ],
      total: 10000.00,
      status: 'posted'
    }
  ]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fromDropdownRef.current && !fromDropdownRef.current.contains(event.target)) {
        setShowFromDropdown(false);
      }
      if (toDropdownRef.current && !toDropdownRef.current.contains(event.target)) {
        setShowToDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const generateReference = () => {
    const count = journalEntries.length + 1;
    return `TRF${count.toString().padStart(3, '0')}`;
  };

  const handleTransfer = async () => {
    if (transferAmount && selectedFromAccount && selectedToAccount && selectedFromAccount.id !== selectedToAccount.id) {
      const amount = parseFloat(transferAmount);
      const refNumber = reference || generateReference();

      // Create journal entry
      const newEntry = {
        id: journalEntries.length + 1,
        date: new Date().toISOString().split('T')[0],
        reference: refNumber,
        description: description || `Transfer from ${selectedFromAccount.name} to ${selectedToAccount.name}`,
        entries: [
          {
            account: selectedToAccount.id,
            accountName: selectedToAccount.name,
            debit: selectedToAccount.normalBalance === 'debit' ? amount : 0,
            credit: selectedToAccount.normalBalance === 'credit' ? amount : 0
          },
          {
            account: selectedFromAccount.id,
            accountName: selectedFromAccount.name,
            debit: selectedFromAccount.normalBalance === 'credit' ? amount : 0,
            credit: selectedFromAccount.normalBalance === 'debit' ? amount : 0
          }
        ],
        total: amount,
        status: 'posted'
      };
 try {
      const payload = {
        transferAmount: transferAmount,
        selectedFromAccount:selectedFromAccount,
        selectedToAccount:selectedToAccount,
        description:description,
        reference:refNumber

      };
       const token = localStorage.getItem('token');
      //console.log('Votehead payload:', payload);
       ////console.log('Fetching CSRF cookie...');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      ////console.log('CSRF Response:', csrfResponse);

      const xsrfToken = getCookie('XSRF-TOKEN');
      ////console.log('XSRF Token:', xsrfToken);
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      const response = await axios.post(`${config.API_URL}/api/saveAccountTransfer`, payload, {
            headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
          withCredentials: true,
          });
window.location.assign(`${config.APP_URL}/Transfer`);
    
    } catch (err) {
      
      alert('Save transfer error:', err);
    } finally {
      setLoading(false);
    }
      
      // Reset form
      setTransferAmount('');
      setSelectedFromAccount(null);
      setSelectedToAccount(null);
      setFromAccountSearch('');
      setToAccountSearch('');
      setDescription('');
      setReference('');
      setShowTransferModal(false);
    }
  };

  const getAccountTypeColor = (type) => {
    const colors = {
      asset: 'bg-blue-50 text-blue-700 border-blue-200',
      liability: 'bg-red-50 text-red-700 border-red-200',
      equity: 'bg-purple-50 text-purple-700 border-purple-200',
      revenue: 'bg-green-50 text-green-700 border-green-200',
      expense: 'bg-orange-50 text-orange-700 border-orange-200'
    };
    return colors[type] || 'bg-gray-50 text-gray-700 border-gray-200';
  };

  const getAccountIcon = (type) => {
    const icons = {
      asset: Building2,
      liability: CreditCard,
      equity: TrendingUp,
      revenue: TrendingUp,
      expense: TrendingDown
    };
    const Icon = icons[type] || Building2;
    return <Icon className="w-4 h-4" />;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(Math.abs(amount));
  };

  const calculateTotalsByType = () => {
    return accounts.reduce((totals, acc) => {
      totals[acc.type] = (totals[acc.type] || 0) + acc.balance;
      return totals;
    }, {});
  };

  // Filter accounts based on search
  const getFilteredAccounts = (searchTerm, excludeId = null) => {
    return accounts.filter(account => {
      if (excludeId && account.id === excludeId) return false;
      const searchLower = searchTerm.toLowerCase();
      return (
        account.name.toLowerCase().includes(searchLower) ||
        account.code.toLowerCase().includes(searchLower) ||
        account.type.toLowerCase().includes(searchLower)
      );
    });
  };

  // Group accounts by type for better organization
  const groupAccountsByType = (filteredAccounts) => {
    const groups = filteredAccounts.reduce((acc, account) => {
      if (!acc[account.type]) acc[account.type] = [];
      acc[account.type].push(account);
      return acc;
    }, {});

    // Sort groups by typical accounting order
    const typeOrder = ['asset', 'liability', 'equity', 'revenue', 'expense'];
    return typeOrder.filter(type => groups[type]).map(type => ({
      type,
      accounts: groups[type].sort((a, b) => a.code.localeCompare(b.code))
    }));
  };

  const totals = calculateTotalsByType();

  // Account Selector Component
  const AccountSelector = ({ 
    label, 
    searchValue, 
    setSearchValue, 
    selectedAccount, 
    setSelectedAccount, 
    showDropdown, 
    setShowDropdown, 
    dropdownRef, 
    excludeAccountId, 
    placeholder 
  }) => {
    const filteredAccounts = getFilteredAccounts(searchValue, excludeAccountId);
    const groupedAccounts = groupAccountsByType(filteredAccounts);

     if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
          <p className="text-base text-gray-600 font-medium">Loading accounts...</p>
        </div>
      </div>
    );
  }

    return (
      <div className="relative" ref={dropdownRef}>
        <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
        
        {/* Selected Account Display or Search Input */}
        {selectedAccount ? (
          <div className="w-full p-3 border border-gray-200 rounded-xl bg-gray-50 flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className={`p-2 rounded-lg ${getAccountTypeColor(selectedAccount.type)}`}>
                {getAccountIcon(selectedAccount.type)}
              </div>
              <div>
                <p className="font-medium text-gray-900">{selectedAccount.name}</p>
                <p className="text-sm text-gray-500">{selectedAccount.code} • {formatCurrency(selectedAccount.balance)}</p>
              </div>
            </div>
            <button
              onClick={() => {
                setSelectedAccount(null);
                setSearchValue('');
                setShowDropdown(true);
              }}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        ) : (
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setShowDropdown(true);
              }}
              onFocus={() => setShowDropdown(true)}
              placeholder={placeholder}
              className="w-full pl-10 pr-10 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200"
            />
            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          </div>
        )}

        {/* Dropdown */}
        {showDropdown && !selectedAccount && (
          <div className="absolute z-50 w-full cursor-pointer mt-2 bg-white border border-gray-200 rounded-xl shadow-lg max-h-80 overflow-y-auto">
            {groupedAccounts.length > 0 ? (
              groupedAccounts.map(group => (
                <div key={group.type} className="p-2" >
                  <div className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                    {group.type}s ({group.accounts.length})
                  </div>
                  {group.accounts.map(account => (
                    <button
                      key={account.id}
                      onClick={() => {
                       
                        setSelectedAccount(account);
                        setShowDropdown(false);
                        setSearchValue('');
                      }}
                      className="w-full p-3 hover:bg-gray-50 rounded-lg transition-colors duration-150 flex items-center space-x-3"
                    >
                      <div className={`p-2 rounded-lg ${getAccountTypeColor(account.type)}`}>
                        {getAccountIcon(account.type)}
                      </div>
                      <div className="flex-1 text-left">
                        <p className="font-medium text-gray-900">{account.name}</p>
                        <p className="text-sm text-gray-500">{account.code} • {formatCurrency(account.balance)}</p>
                      </div>
                    </button>
                  ))}
                </div>
              ))
            ) : (
              <div className="p-4 text-center text-gray-500">
                <Search className="w-8 h-8 mx-auto mb-2 text-gray-300" />
                <p>No accounts found</p>
                <p className="text-xs">Try adjusting your search</p>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="max-w-7xl mx-auto p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Account Transfers</h1>
          <p className="text-gray-600">Account transfers with automatic journal entries.</p>
        </div>
        <button 
          onClick={() => setShowTransferModal(true)}
          className="bg-black text-white px-6 py-3 rounded-xl font-medium hover:bg-gray-800 transition-colors duration-200 flex items-center space-x-2 shadow-sm"
        >
          <ArrowRightLeft className="w-5 h-5" />
          <span>New Transfer</span>
        </button>
      </div>

      {/* Account Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8 cursor-pointer" title="Click to view account transactions">
        {Object.entries(totals).map(([type, total]) => (
          <div key={type}   onClick={() => navigate(`/chart-of-accounts/${type}`)} className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
            <div className="flex items-center space-x-3">
              <div className={`p-2 rounded-lg ${getAccountTypeColor(type)}`}>
                {getAccountIcon(type)}
              </div>
              <div>
                <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">{type}</p>
                <p className="text-lg font-bold text-gray-900">{formatCurrency(total)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm mb-6">
        <div className="flex border-b border-gray-100">
          {[
            { id: 'transfer', label: 'Recent Transfers' },
            { id: 'accounts', label: 'Chart of Accounts' }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors duration-200 ${
                activeTab === tab.id 
                  ? 'border-black text-black' 
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content based on active tab */}
        {activeTab === 'transfer' && (
          <div>
            <div className="p-6 border-b border-gray-100">
              <div className="flex flex-col sm:flex-row gap-4">
               {/* <div className="flex-1 relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="text"
                     value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search transfers..."
                    className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200"
                  />
                </div>*/}
               
              </div>
            </div>

            <div className="divide-y divide-gray-100">
              {journalEntries.map(entry => (
                <div key={entry.id} className="p-6 hover:bg-gray-50 transition-colors duration-150">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-4">
                      <div className="bg-blue-50 p-3 rounded-xl text-blue-600">
                        <ArrowRightLeft className="w-5 h-5" />
                      </div>
                      <div>
                        <p className="font-semibold text-gray-900 mb-1">{entry.description}</p>
                        <div className="flex items-center space-x-3 text-sm text-gray-500">
                          <span>{entry.reference}</span>
                          <span>•</span>
                          <span>{new Date(entry.date).toLocaleDateString()}</span>
                          <span>•</span>
                          <div className="flex items-center space-x-1">
                            <CheckCircle className="w-4 h-4 text-green-600" />
                            <span className="text-green-600 font-medium">Posted</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-bold text-gray-900">{formatCurrency(entry.total)}</p>
                    </div>
                  </div>
                  
                  {/* Journal Entry Details */}
                  <div className="ml-16 bg-gray-50 rounded-xl p-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {entry.entries.map((entryLine, idx) => (
                        <div key={idx} className="flex items-center justify-between p-3 bg-white rounded-lg">
                          <div>
                            <p className="font-medium text-gray-900">{entryLine.accountName}</p>
                            <p className="text-sm text-gray-500">{entryLine.debit > 0 ? 'Debit' : 'Credit'}</p>
                          </div>
                          <p className="font-bold text-gray-900">
                            {formatCurrency(entryLine.debit > 0 ? entryLine.debit : entryLine.credit)}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'accounts' && (
          <div>
            <div className="p-6 border-b border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Chart of Accounts ({accounts.length} accounts)</h3>
            </div>
            <div className="divide-y divide-gray-100">
              {groupAccountsByType(accounts).map(group => (
                <div key={group.type}>
                  <div className="px-6 py-3 bg-gray-50 border-b border-gray-100">
                    <h4 className="text-sm font-semibold text-gray-600 uppercase tracking-wider">
                      {group.type}s ({group.accounts.length})
                    </h4>
                  </div>
                  {group.accounts.map(account => (
                    <div key={account.id} className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors duration-150">
                      <div className="flex items-center space-x-4">
                        <div className={`p-3 rounded-xl border ${getAccountTypeColor(account.type)}`}>
                          {getAccountIcon(account.type)}
                        </div>
                        <div>
                          <div className="flex items-center space-x-3 mb-1">
                            <p className="font-semibold text-gray-900">{account.name}</p>
                            <span className="text-xs font-mono bg-gray-100 text-gray-600 px-2 py-1 rounded">
                              {account.code}
                            </span>
                          </div>
                          <div className="flex items-center space-x-3 text-sm text-gray-500">
                            <span className="capitalize">{account.category}</span>
                            <span>•</span>
                            <span>Normal: {account.normalBalance}</span>
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-bold text-gray-900">{formatCurrency(account.balance)}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Enhanced Transfer Modal */}
      {showTransferModal && (
        <div className="fixed Modal inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-2xl font-bold text-gray-900">Create Account Transfer</h2>
              <p className="text-gray-600 mt-1">Transfer funds between accounts with automatic journal entries</p>
            </div>
            
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
              <div className="space-y-6">
                {/* From Account */}
                <AccountSelector
                  label="From Account (Credit)"
                  searchValue={fromAccountSearch}
                  setSearchValue={setFromAccountSearch}
                  selectedAccount={selectedFromAccount}
                  setSelectedAccount={setSelectedFromAccount}
                  showDropdown={showFromDropdown}
                  setShowDropdown={setShowFromDropdown}
                  dropdownRef={fromDropdownRef}
                  excludeAccountId={selectedToAccount?.id}
                  placeholder="Search for source account..."
                />

                {/* Transfer Arrow */}
                {selectedFromAccount && selectedToAccount && (
                  <div className="flex justify-center">
                    <div className="bg-black text-white p-3 rounded-full">
                      <ArrowRight className="w-5 h-5" />
                    </div>
                  </div>
                )}

                {/* To Account */}
                <AccountSelector
                  label="To Account (Debit)"
                  searchValue={toAccountSearch}
                  setSearchValue={setToAccountSearch}
                  selectedAccount={selectedToAccount}
                  setSelectedAccount={setSelectedToAccount}
                  showDropdown={showToDropdown}
                  setShowDropdown={setShowToDropdown}
                  dropdownRef={toDropdownRef}
                  excludeAccountId={selectedFromAccount?.id}
                  placeholder="Search for destination account..."
                />

                {/* Amount */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Transfer Amount</label>
                  <div className="relative">
                   
                    <input
                      type="number"
                      value={transferAmount}
                      onChange={(e) => setTransferAmount(e.target.value)}
                      placeholder="0.00"
                      className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200 text-lg"
                      min="0"
                      step="0.01"
                    />
                  </div>
                  {selectedFromAccount && transferAmount && (
                    <div className="mt-2 p-3 bg-blue-50 rounded-lg">
                      <p className="text-sm text-blue-700">
                        Available balance: <span className="font-semibold">{formatCurrency(selectedFromAccount.balance)}</span>
                      </p>
                      {parseFloat(transferAmount) > selectedFromAccount.balance && selectedFromAccount.normalBalance === 'debit' && (
                        <p className="text-sm text-red-600 mt-1">
                          ⚠️ Transfer amount exceeds available balance
                        </p>
                      )}
                    </div>
                  )}
                </div>

                {/* Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Transfer Note</label>
                  <input
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder={selectedFromAccount && selectedToAccount 
                      ? `Transfer from ${selectedFromAccount.name} to ${selectedToAccount.name}`
                      : "Enter transfer description..."
                    }
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200"
                  />
                </div>

                {/* Reference */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Reference Number</label>
                  <input
                    type="text"
                    value={reference}
                    onChange={(e) => setReference(e.target.value)}
                    placeholder={generateReference()}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all duration-200"
                  />
                </div>

               
              </div>
            </div>

            <div className="p-6 border-t border-gray-100 bg-gray-50">
              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    setShowTransferModal(false);
                    setSelectedFromAccount(null);
                    setSelectedToAccount(null);
                    setFromAccountSearch('');
                    setToAccountSearch('');
                    setTransferAmount('');
                    setDescription('');
                    setReference('');
                  }}
                  className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-700 font-medium hover:bg-gray-100 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={handleTransfer}
                  disabled={!description || !reference || !transferAmount || !selectedFromAccount || !selectedToAccount || selectedFromAccount.id === selectedToAccount.id}
                  className="flex-1 py-3 px-4 bg-black text-white rounded-xl font-medium hover:bg-gray-800 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center space-x-2"
                >
                  <ArrowRightLeft className="w-4 h-4" />
                  <span>Create Transfer</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountTransferManager;